import styled from "styled-components";

export const LoginSection = styled.div.attrs<{
  $animate: boolean;
}>(({ $animate }) => ({
  className: `transition-all duration-500 ease-out ${
    $animate ? "translate-y-0 opacity-100" : "translate-y-4 opacity-0"
  }`,
}))`` as any;

export const LoginContentStack = styled.div.attrs({
  className: "space-y-6",
})``;

export const LoginSsoCard = styled.div.attrs({
  className:
    "overflow-hidden rounded-[30px] border border-[var(--brand-border)] bg-[linear-gradient(135deg,rgba(8,22,32,0.96),rgba(10,42,52,0.94))] p-5 shadow-[0_24px_54px_rgba(0,0,0,0.32)]",
})``;

export const LoginSsoRow = styled.div.attrs({
  className: "flex flex-col gap-5 sm:flex-row sm:items-center sm:justify-between",
})``;

export const LoginSsoCopy = styled.div.attrs({
  className: "space-y-2",
})``;

export const LoginSsoEyebrow = styled.p.attrs({
  className:
    "inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.28em] text-[var(--brand-highlight)]",
})``;

export const LoginSsoHeading = styled.h2.attrs({
  className: "text-2xl text-[var(--brand-ink)]",
})``;

export const LoginSsoBody = styled.p.attrs({
  className: "max-w-xl text-sm leading-7 text-[var(--brand-muted)]",
})``;

export const LoginSsoButton = styled.button.attrs({
  className:
    "inline-flex min-h-[52px] items-center justify-center gap-2 rounded-full border border-[rgba(255,244,214,0.32)] bg-[linear-gradient(135deg,#f4df9d,#efc96f,#c9922c)] px-5 py-3 text-sm font-semibold text-[#2d1d00] shadow-[0_18px_28px_rgba(201,146,44,0.25)] transition-transform duration-200 hover:-translate-y-0.5 disabled:cursor-not-allowed disabled:opacity-60",
})``;

export const LoginSsoMeta = styled.p.attrs({
  className: "text-xs uppercase tracking-[0.2em] text-[rgba(255,255,255,0.62)]",
})``;
